import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class ConfSessionCommand extends AbstractConfDataCommand {
  email?: string;
  save?: boolean;
  exitEditing?: boolean;
  close?: boolean;
  markForClosing?: boolean;
  restart?: boolean;
}